import {
    GET_ROLE_REQUEST, GET_ROLE_SUCCESS, GET_ROLE_FAIL,
    GET_ALL_ROLES_REQUEST, GET_ALL_ROLES_SUCCESS, GET_ALL_ROLES_FAIL,
    GET_ACTIVE_ROLES_REQUEST, GET_ACTIVE_ROLES_SUCCESS, GET_ACTIVE_ROLES_FAIL,
    GET_ROLES_BY_MODULE_REQUEST, GET_ROLES_BY_MODULE_SUCCESS, GET_ROLES_BY_MODULE_FAIL,
    GET_GLOBAL_ROLES_REQUEST, GET_GLOBAL_ROLES_SUCCESS, GET_GLOBAL_ROLES_FAIL,
    CREATE_ROLE_REQUEST, CREATE_ROLE_SUCCESS, CREATE_ROLE_FAIL,
    UPDATE_ROLE_REQUEST, UPDATE_ROLE_SUCCESS, UPDATE_ROLE_FAIL,
    DELETE_ROLE_REQUEST, DELETE_ROLE_SUCCESS, DELETE_ROLE_FAIL,
    SET_SELECTED_ROLE, SET_ROLE_LOADING
} from '../actions/roleActions';

const initialState = {
    roles: [],
    currentRole: null,
    selectedRole: null, // Rôle actuellement sélectionné par l'utilisateur
    loading: false,
    message: '',
    error: null
};

function roleReducer(state = initialState, action) {
    switch (action.type) {
        // --- Sélectionner un rôle ---
        case SET_SELECTED_ROLE:
            return {
                ...state,
                selectedRole: action.payload
            };

        // --- SET LOADING ---
        case SET_ROLE_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        // --- Récupérer un rôle ---
        case GET_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ROLE_SUCCESS:
            return {
                ...state,
                currentRole: action.payload,
                loading: false,
                message: 'Rôle récupéré avec succès'
            };
        case GET_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer tous les rôles ---
        case GET_ALL_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ALL_ROLES_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: ''
            };
        case GET_ALL_ROLES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer rôles actifs ---
        case GET_ACTIVE_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ACTIVE_ROLES_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: 'Rôles actifs récupérés avec succès'
            };
        case GET_ACTIVE_ROLES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer rôles par module ---
        case GET_ROLES_BY_MODULE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ROLES_BY_MODULE_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: 'Rôles filtrés par module avec succès'
            };
        case GET_ROLES_BY_MODULE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer rôles globaux ---
        case GET_GLOBAL_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_GLOBAL_ROLES_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: 'Rôles globaux récupérés avec succès'
            };
        case GET_GLOBAL_ROLES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Créer un rôle ---
        case CREATE_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_ROLE_SUCCESS:
            return {
                ...state,
                roles: [...state.roles, action.payload],
                loading: false,
                message: 'Rôle créé avec succès'
            };
        case CREATE_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Mettre à jour un rôle ---
        case UPDATE_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_ROLE_SUCCESS:
            return {
                ...state,
                roles: state.roles.map(role =>
                    role.id === action.payload.id ? action.payload : role
                ),
                currentRole: state.currentRole?.id === action.payload.id
                    ? action.payload
                    : state.currentRole,
                loading: false,
                message: 'Rôle mis à jour avec succès'
            };
        case UPDATE_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Supprimer un rôle ---
        case DELETE_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_ROLE_SUCCESS:
            return {
                ...state,
                roles: state.roles.filter(role => role.id !== action.payload.roleId),
                currentRole: state.currentRole?.id === action.payload.roleId
                    ? null
                    : state.currentRole,
                loading: false,
                message: 'Rôle supprimé avec succès'
            };
        case DELETE_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default roleReducer;